import gql from 'graphql-tag';

export const UPDATE_BUSINESS_OWNER = gql`
  mutation updateBusinessOwner(
    $id: Int!
    $password: String!
    $token: String!
    $isResetPassword: Boolean
    $isConfirmPassword: Boolean
  ) {
    updateBusinessOwner(
      id: $id
      password: $password
      token: $token
      isResetPassword: $isResetPassword
      isConfirmPassword: $isConfirmPassword
    ) {
      id
    }
  }
`;

export const CREATE_BUSINESS_OWNER = gql`
  mutation createBusinessOwner($businessOwner: BusinessOwnerInput) {
    createBusinessOwner(businessOwner: $businessOwner) {
      id
    }
  }
`;

export const DELETE_BUSINESS_OWNER = gql`
  mutation deleteBusinessOwner($businessOwnerId: Int!) {
    deleteBusinessOwner(businessOwnerId: $businessOwnerId) {
      id
    }
  }
`;

export const UPDATE_BUSINESS_OWNER_USER = gql`
  mutation updateBusinessOwnerUser($businessOwner: BusinessOwnerInput) {
    updateBusinessOwnerUser(businessOwner: $businessOwner) {
      id
    }
  }
`;
